// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* EditTask.css - Tiptap Editor Styles */

/* Стилі для контенту Tiptap редактора */
.ProseMirror {
    min-height: 300px;
    /* Мінімальна висота редактора */
    border: 1px solid #e7e7eb;
    /* Mantine gray-4 */
    border-radius: 4px;
    padding: 15px;
    outline: none;
    /* Прибираємо стандартний outline при фокусі */
    line-height: 1.7;
    background-color: #fff;
}

.ProseMirror:focus {
    border-color: #a39add;
    /* Mantine blue-6 */
}

/* Головне правило: зображення всередині редактора */
.ProseMirror img {
    max-width: 100%;
    /* Гарантує, що зображення не вийде за межі батьківського елемента */
    height: auto;
    /* Зберігає співвідношення сторін */
    display: block;
    /* Усуває зайві пробіли під зображенням */
}

/* Стилі для resize-хендлів (якщо ви хочете їх кастомізувати) */
.ProseMirror .resize-image-wrapper {
    position: relative;
    display: inline-block;
    /* Або block, залежно від бажаної поведінки */
}

.ProseMirror .resize-image-wrapper .resize-handle {
    position: absolute;
    width: 10px;
    height: 10px;
    background: #a39add;
    /* Mantine blue-6 */
    /* Колір хендлів */
    border: 1px solid #fff;
    border-radius: 50%;
    cursor: nwse-resize;
    /* Курсор для зміни розміру */
    z-index: 10;
}

/* Розташування хендлів */
.ProseMirror .resize-image-wrapper .resize-handle.top-left {
    top: -5px;
    left: -5px;
}

.ProseMirror .resize-image-wrapper .resize-handle.top-right {
    top: -5px;
    right: -5px;
}

.ProseMirror .resize-image-wrapper .resize-handle.bottom-left {
    bottom: -5px;
    left: -5px;
}

.ProseMirror .resize-image-wrapper .resize-handle.bottom-right {
    bottom: -5px;
    right: -5px;
}`, "",{"version":3,"sources":["webpack://./src/components/styles/EditTask.css"],"names":[],"mappings":"AAAA,wCAAwC;;AAExC,wCAAwC;AACxC;IACI,iBAAiB;IACjB,gCAAgC;IAChC,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,aAAa;IACb,8CAA8C;IAC9C,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA,oDAAoD;AACpD;IACI,eAAe;IACf,oEAAoE;IACpE,YAAY;IACZ,mCAAmC;IACnC,cAAc;IACd,yCAAyC;AAC7C;;AAEA,+DAA+D;AAC/D;IACI,kBAAkB;IAClB,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,6BAA6B;IAC7B,WAAW;AACf;;AAEA,yBAAyB;AACzB;IACI,SAAS;IACT,UAAU;AACd;;AAEA;IACI,SAAS;IACT,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,WAAW;AACf","sourcesContent":["/* EditTask.css - Tiptap Editor Styles */\n\n/* Стилі для контенту Tiptap редактора */\n.ProseMirror {\n    min-height: 300px;\n    /* Мінімальна висота редактора */\n    border: 1px solid #e7e7eb;\n    /* Mantine gray-4 */\n    border-radius: 4px;\n    padding: 15px;\n    outline: none;\n    /* Прибираємо стандартний outline при фокусі */\n    line-height: 1.7;\n    background-color: #fff;\n}\n\n.ProseMirror:focus {\n    border-color: #a39add;\n    /* Mantine blue-6 */\n}\n\n/* Головне правило: зображення всередині редактора */\n.ProseMirror img {\n    max-width: 100%;\n    /* Гарантує, що зображення не вийде за межі батьківського елемента */\n    height: auto;\n    /* Зберігає співвідношення сторін */\n    display: block;\n    /* Усуває зайві пробіли під зображенням */\n}\n\n/* Стилі для resize-хендлів (якщо ви хочете їх кастомізувати) */\n.ProseMirror .resize-image-wrapper {\n    position: relative;\n    display: inline-block;\n    /* Або block, залежно від бажаної поведінки */\n}\n\n.ProseMirror .resize-image-wrapper .resize-handle {\n    position: absolute;\n    width: 10px;\n    height: 10px;\n    background: #a39add;\n    /* Mantine blue-6 */\n    /* Колір хендлів */\n    border: 1px solid #fff;\n    border-radius: 50%;\n    cursor: nwse-resize;\n    /* Курсор для зміни розміру */\n    z-index: 10;\n}\n\n/* Розташування хендлів */\n.ProseMirror .resize-image-wrapper .resize-handle.top-left {\n    top: -5px;\n    left: -5px;\n}\n\n.ProseMirror .resize-image-wrapper .resize-handle.top-right {\n    top: -5px;\n    right: -5px;\n}\n\n.ProseMirror .resize-image-wrapper .resize-handle.bottom-left {\n    bottom: -5px;\n    left: -5px;\n}\n\n.ProseMirror .resize-image-wrapper .resize-handle.bottom-right {\n    bottom: -5px;\n    right: -5px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
